import { render, staticRenderFns } from "./BenefitsHome.vue?vue&type=template&id=adc49d5a"
import script from "./BenefitsHome.vue?vue&type=script&setup=true&lang=js"
export * from "./BenefitsHome.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports